import { Environment } from '@dice/app/types/env.type';
import { NgxLoggerLevel } from 'ngx-logger';

const host = 'localhost:9090/';
const http = 'http://';
const ws = 'ws://';

export const LOCAL_ENV_CONFIG: Environment = {
  name: 'sc-local',
  hostNames: ['localhost:5000'],
  enableDebugInfo: true,
  isProduction: false,
  publicStates: ['login'],
  apiEndpoint: `${http + host}`,
  wsEndpoint: `${ws + host}`,
  wsEndpointForUCCP: `${ws + host}`,
  agentViewEndpoint: `agent-view/`,
  agentViewStatisticsConsumerEndpoint: `agent-view-statistics/`,
  agentInfoStatisticsConsumerEndpoint: `buda-message-proxy-agentinfo/`,
  anomalyEndpoint: `dice-anomalies/api/anomalies/`,
  auditingEndpoint: `auditing/`,
  budaConfigurationEndpoint: `http://localhost:8787/`,
  budaStatisticsConsumerEndpoint: 'buda-statistics/',
  budaStatisticsConsumerEndpointForUCCP: 'buda-statistics/',
  configEndpoint: `dice-config/api/config/`,
  easyArchitectEndpoint: `http://localhost:8083/`,
  datatableBackupEndpoint: `http://localhost:8084/`,
  callbackAdminEndpoint: `http://localhost:8080/`,
  businessInsightsEndpoint: 'https://uccp-soi-business-insights.uccp-integration-dev.icp.corproot.net/',
  dataExchangeEndpoint: `data-exchange/`,
  diceUiRedirectPage: 'https://dice-ui.scapp-corp.swisscom.com/',
  eimaEndpoint: `eima/`,
  eimaDREndpoint: `eima-dr/`,
  notifications: `${ws + host}notification/push-message-endpoint`,
  octEndpoint: `chat-campaign-tool/`,
  statisticsConsumerEndpoint: `http://localhost:8989/websocket`,
  transfertoolAdminURL: 'https://www.dev2.swisscom.ch/omni-transfertool-admin/login',
  userManagementEndpoint: `user-management/`,
  userManualURL: 'https://wiki.swisscom.com/pages/viewpage.action?pageId=617222684',
  logEndpoint: '',
  logLevel: NgxLoggerLevel.DEBUG,
  serverLogLevel: NgxLoggerLevel.OFF,
  variant: '',
  agentViewManualURL: 'https://wiki.swisscom.com/x/3yHdL',
  budaStatusURL: 'http://localhost:4200',
  cxGenesysModifierURL: 'http://localhost:4200',
  apiProviderURL: 'http://localhost:4200',
};
